import { withInstall } from '@hd-front-end/utils'
import Watermark from './src/watermark.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElWatermark: SFCWithInstall<typeof Watermark> =
  withInstall(Watermark)
export default ElWatermark

export * from './src/watermark'
